import React from 'react';
import { BarChart, Bar, LineChart, Line, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { GroupedRow } from '../../utils/reportEngine';
import { ChartType } from '../../data/reports';
const PALETTE = ['#102a43', '#0e7490', '#B98723', '#627d98', '#06b6d4', '#9fb3c8', '#dcb668'];
const tooltipStyle = {
  fontSize: 12,
  borderRadius: 10,
  border: '1px solid #d9e2ec',
  background: '#ffffff',
  color: '#243b53',
  boxShadow: '0 8px 24px -12px rgba(16,42,67,0.18)'
};
interface ReportChartProps {
  data: GroupedRow[];
  chartType: ChartType;
  metricLabel: string;
}
export function ReportChart({
  data,
  chartType,
  metricLabel
}: ReportChartProps) {
  if (data.length === 0) {
    return <div className="flex h-72 items-center justify-center text-sm text-navy-400" data-id="element-166">
        No data matches the current filters.
      </div>;
  }
  if (chartType === 'pie') {
    return <div className="h-72 w-full" data-id="element-167">
        <ResponsiveContainer width="100%" height="100%" data-id="element-168">
          <PieChart data-id="element-169">
            <Pie data={data} dataKey="value" nameKey="group" innerRadius={58} outerRadius={95} paddingAngle={3} stroke="#ffffff" strokeWidth={2} data-id="element-170">
              {data.map((entry, i) => <Cell key={entry.group} fill={PALETTE[i % PALETTE.length]} data-id="element-171" />)}
            </Pie>
            <Tooltip formatter={(value: number) => [value, metricLabel]} contentStyle={tooltipStyle} data-id="element-172" />
            <Legend wrapperStyle={{
            fontSize: 12,
            color: '#627d98'
          }} data-id="element-173" />
          </PieChart>
        </ResponsiveContainer>
      </div>;
  }
  if (chartType === 'line') {
    return <div className="h-72 w-full" data-id="element-174">
        <ResponsiveContainer width="100%" height="100%" data-id="element-175">
          <LineChart data={data} margin={{
          top: 8,
          right: 16,
          left: -8,
          bottom: 4
        }} data-id="element-176">
            <CartesianGrid strokeDasharray="3 3" stroke="#e4eaf2" vertical={false} data-id="element-177" />
            <XAxis dataKey="group" tick={{
            fontSize: 11,
            fill: '#829ab1'
          }} tickLine={false} axisLine={{
            stroke: '#d9e2ec'
          }} data-id="element-178" />
            <YAxis tick={{
            fontSize: 11,
            fill: '#829ab1'
          }} tickLine={false} axisLine={false} data-id="element-179" />
            <Tooltip formatter={(value: number) => [value, metricLabel]} contentStyle={tooltipStyle} data-id="element-180" />
            <Line type="monotone" dataKey="value" stroke="#0e7490" strokeWidth={2} dot={{
            r: 3,
            fill: '#0e7490',
            strokeWidth: 0
          }} activeDot={{
            r: 5,
            fill: '#102a43'
          }} name={metricLabel} data-id="element-181" />
          </LineChart>
        </ResponsiveContainer>
      </div>;
  }
  return <div className="h-72 w-full" data-id="element-182">
      <ResponsiveContainer width="100%" height="100%" data-id="element-183">
        <BarChart data={data} margin={{
        top: 8,
        right: 16,
        left: -8,
        bottom: 4
      }} data-id="element-184">
          <CartesianGrid strokeDasharray="3 3" stroke="#e4eaf2" vertical={false} data-id="element-185" />
          <XAxis dataKey="group" tick={{
          fontSize: 11,
          fill: '#829ab1'
        }} tickLine={false} axisLine={{
          stroke: '#d9e2ec'
        }} interval={0} data-id="element-186" />
          <YAxis tick={{
          fontSize: 11,
          fill: '#829ab1'
        }} tickLine={false} axisLine={false} data-id="element-187" />
          <Tooltip formatter={(value: number) => [value, metricLabel]} cursor={{
          fill: '#f0f4f8'
        }} contentStyle={tooltipStyle} data-id="element-188" />
          <Bar dataKey="value" name={metricLabel} radius={[6, 6, 0, 0]} maxBarSize={44} data-id="element-189">
            {data.map((entry, i) => <Cell key={entry.group} fill={PALETTE[i % PALETTE.length]} data-id="element-190" />)}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>;
}